import React from "react";

export default function FA5_Date_Time() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">FA5_Date_Time</h2>
      <p>Route: /icons/fa5/date-time</p>
    </div>
  );
}
